export default "__VITE_ASSET__iOLp2a1v__"